import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { forwardRef } from 'react';
import classes from './Button.module.scss';

export interface NbButtonProp extends ButtonProps {
  id?: string;
  className?: string;
  isLoading?: boolean;
  loaderSize?: number;
}

export const NbButton = forwardRef<HTMLButtonElement | null, NbButtonProp>(
  ({ className, variant = `contained`, disabled, isLoading, loaderSize, ...props }: NbButtonProp, ref) => {
    return (
      <Button
        className={`${classes.nbButton} ${className ?? ''}`}
        classes={{
          containedPrimary: classes.nbButtonIsContainedPrimary,
          textPrimary: classes.nbButtonIsTextPrimary,
          outlinedPrimary: classes.nbButtonIsOutlinedPrimary,
          containedSecondary: classes.nbButtonIsContainedSecondary,
          textSecondary: classes.nbButtonIsTextSecondary,
          outlinedSecondary: classes.nbButtonIsOutlinedSecondary,
        }}
        variant={variant}
        disabled={isLoading || disabled}
        {...props}
        ref={ref}
      >
        {isLoading && (
          <CircularProgress
            size={loaderSize || 24}
            sx={{ position: 'absolute' }}
          />
        )}
        {props.children}
      </Button>
    );
  },
);
